<template>
  <div id="sgz-wrapper">
    <navigation />

    <sgz-header />
    <!--            <how-to-play/>-->
    <div id="sgz-top-gradient"></div>
    <main-footer
      class="sgz-footer"
      siteName="Survivor GameZ"
      :socialLinks="false"
      :copyrightLinks="[]"
    />
    <!--        <form-popup/>-->
  </div>
</template>

<script>
import Navigation from "@/components/SurvivorGamez/Navigation";
import SgzHeader from "@/components/SurvivorGamez/Header";
import HowToPlay from "@/components/SurvivorGamez/HowToPlay";
import RequestForm from "@/components/SurvivorGamez/RequestForm";
import MainFooter from "@/components/MainFooter";
import FormPopup from "@/components/SurvivorGamez/FormPopup";

export default {
  components: {
    MainFooter,
    Navigation,
    SgzHeader,
    HowToPlay,
    RequestForm,
    FormPopup
  },
  metaInfo: {
    title: "Survivor Gamez"
  }
};
</script>

<style></style>

<style lang="scss" scoped>
#sgz-wrapper {
  background: url("/img/bg/KeyArt_SGZ.jpg") no-repeat center top #000000;
  background-size: cover;
  min-height: 100vh;
  position: relative;

  @media (max-width: 1400px) {
    background-image: url("/img/bg/KeyArt_SGZ_1400.png");
  }
}

#sgz-top-gradient {
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.sgz-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>
